<template>
  <button
    class="add-card-toolbar-icon pt flex items-center justify-center"
    @click="effect"
  >
    <span class="rounded-full border border-solid color-button-border">
      <em
        class="custom-icons page-toolbar group-hover:bg-icon-hover"
        :style="{ ...getCustomIconStyle(iconPath('circle-full')) }"
        :data-st-table-color="props.color"
      />
    </span>
  </button>
</template>

<script setup lang="ts">
import useCustomIcon from '@/utilities/composables/useCustomIcon';

const props = defineProps<{
  effect: (color: string) => () => void;
  color: string;
}>();

const { iconPath, getCustomIconStyle } = useCustomIcon();
</script>

<style lang="scss" scoped>
.color-button-border {
  border-color: var(--emphasisedBorder);
}
</style>
